import React from "react";

class About extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div>
        <section className="page-header">
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col-md-12">
                <div className="breadcrumb-wrapper text-center">
                  <h2>Timesheets for Jira Docs</h2>
                  <p>
                    <a href="index.html">Home </a>/ Documentation
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div id="blog-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-12 col-xs-12">
                <div className="blog-post">
                  <div className="post-thumb">
                    <img src="assets/img/blog/create-filter.png" alt="" />
                  </div>
                  <div style={{ color: "#42526E" }} className="post-content">
                    <h3>Custom filter</h3>
                    <p>
                      1-Project : By defaults, all JIRA instance projects will
                      be included, select one or more projects in this field.
                      You have semi automatic search to speed up your selection
                    </p>

                    <p>
                      2-Group : By default, all groups are selected, if you
                      customize this field, User field will be automatically
                      updated depending on groups you use.
                    </p>

                    <p>
                      3-User : If you want to add some users to your request, or
                      to exclude some of them, you have to use this field. Semi
                      automatic search helps you to find your target
                    </p>

                    <p>
                      4-Filter : If you just want to list timesheets depending
                      on previously saved filter on your JIRA instance, you pick
                      up that filter on this field.
                    </p>

                    <p>
                      5-Range : Can be weeks (- nb) starting from today.
                      Otherwise, you can define a date range.
                    </p>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="blog-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-12 col-xs-12">
                <div className="blog-post">
                  <div className="post-thumb">
                    <img src="assets/img/blog/create-filter-day.png" alt="" />
                  </div>
                  <div style={{ color: "#42526E" }} className="post-content">
                    <h3>Display results</h3>
                    <p>
                      1-Display : the results in hours or days. By default, the
                      day duration will take its value from your JIRA
                      configuration. But you can override it. You may have
                      partners that work with another day costs (8.5 hours, 9
                      hours etc..) and you can generate timesheets depending on
                      your needs.
                    </p>

                    <p>
                      2-Generate charts : If you want just the table, let it
                      Off. The On mode will generate dynamic pie charts to see
                      further details (section below).
                    </p>

                    <p>
                      3-Remove inactive users : You can hide from tables and
                      charts users with 0 minutes of work. Turn the ON button to
                      remove those inactive users.
                    </p>

                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="blog-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-12 col-xs-12">
                <div className="blog-post">
                  <div className="post-thumb">
                    <img src="assets/img/blog/table.png" alt="" />
                  </div>
                  <div style={{ color: "#42526E" }} className="post-content">
                    <h3>Table</h3>
                    <p>1-table customizatiom.</p>

                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="blog-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-12 col-xs-12">
                <div className="blog-post">
                  <div className="post-thumb">
                    <img src="assets/img/blog/chart.png" alt="" />
                  </div>
                  <div style={{ color: "#42526E" }} className="post-content">
                    <h3>Charts</h3>
                    <p>
                      1-You can click on charts sections to generate sub-tables
                      with issues or projects links . You can also click
                      directly on the name of the section (The list on the right
                      side on each chart)
                    </p>
                    <p>
                      2-Pie chart on the left gives you a quick overview on
                      users participation to projects . By clicking on one
                      section, a table with the list of issues will be
                      generated.
                    </p>
                    <p>
                      3-Pie chart on the right gives you an overview of projects
                      costs depending on your filters. By clicking on one
                      section, you will have the details by project and by
                      users.
                    </p>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="blog-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-12 col-xs-12">
                <div className="blog-post">
                  <div className="post-thumb">
                    <img src="assets/img/blog/calendar.png" alt="" />
                  </div>
                  <div style={{ color: "#42526E" }} className="post-content">
                    <h3>Calendar</h3>
                    <p>
                      If you have the calendar version please go to Calendar
                      functionnality.
                    </p>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js